export default "__VITE_ASSET__DrNQqgDT__"